module.exports = __webpack_public_path__ + "img/cross_close.a4063f70.svg";